import { lazy } from 'react';
/** Открывает форму подписки */
export const SubscriptionFormPageAsync = lazy(() => import('./SubscriptionForm/SubscriptionFormPage'));